import { AppRouteConfigContext } from '@b2c/hooks';
import { ContextGuard, ContextProviders } from '@b2c/ui';
import DefaultMessages from 'locales/en-US.json';
import { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Loading } from 'react-vant';
import { AppConfig } from './app.config';
import { Layout } from './layout/layout';
import routes from './routes';

export function App() {
  const location = useLocation();

  useEffect(() => {
    if ((location.pathname + '/').startsWith('/p/')) {
      const location = window.location;
      location.replace(
        `${location.origin}${location.pathname.slice(2)}${location.search}`
      );
    }
  }, [location.pathname]);

  return (
    <ContextProviders defaultMessage={DefaultMessages} appConfig={AppConfig}>
      <Routes>
        {routes?.map((route, subIndex) => {
          const { data = {}, guardOption = {} } = route;
          return (
            <Route
              key={subIndex}
              path={route.path}
              element={
                <AppRouteConfigContext.Provider value={data}>
                  <Layout theme={route.data?.theme}>
                    <ContextGuard guardOption={guardOption} title={route.title}>
                      <Suspense fallback={<Loading />}>
                        <route.component />
                      </Suspense>
                    </ContextGuard>
                  </Layout>
                </AppRouteConfigContext.Provider>
              }
            />
          );
        })}
      </Routes>
    </ContextProviders>
  );
}

export default App;
